import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFieldComponent } from '../dynamic-field/dynamic-field.component';
import { ResolverModule } from '../resolver/resolver.module';
import { ValidationsModule } from '../../validations/validations.module';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

@NgModule({
  declarations: [DynamicFieldComponent],
  exports: [DynamicFieldComponent],
  imports: [ResolverModule, ValidationsModule, CommonModule, SharedUiLibraryModule]
})
export class BuildingBlockSharedModule {}
